export function ErroreCampo({ campo, messaggio }: { campo: string; messaggio?: string }) {
  return messaggio ? <p id={`errore-${campo}`} className="errore-campo">{messaggio}</p> : null;
}

export function attributiErrore(campo: string, campi: Record<string, string>) {
  return {
    "aria-invalid": campi[campo] ? true : undefined,
    "aria-describedby": campi[campo] ? `errore-${campo}` : undefined,
  };
}
